import superagent from 'superagent'

export const setAppMessage = message => ({
  type: 'SET_APP_MESSAGE',
  payload: message,
})

export const clearAppMessage = () => ({
  type: 'CLEAR_APP_MESSAGE',
})

// Asking for a message is itself a side effect: AppMessageServices.GetAsync records a view,
// decrements the launch countdown and advances the user's frequency ladder. So this fires
// exactly once per app load, from Landing's start-up block, and is never retried — a retry
// would burn a second view and skew the stats the admin page reports.
//
// Nothing to show is the ordinary case, not an error: the endpoint answers 204 when no
// message wins, which superagent surfaces as an empty body rather than a failure.
export const fetchAppMessage = () => (dispatch, getState, token) =>
  new Promise(resolve => {
    superagent
      .get(`${__API_URI__}/AppMessage/Get`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          // Offline or a server error — the popup is promotional, so it is dropped for this
          // session rather than surfaced to the user.
          console.warn('fetchAppMessage failed, skipping popup.', err)
          return resolve(null)
        }

        const message = res.body && res.body.id ? res.body : null
        if (message) dispatch(setAppMessage(message))
        resolve(message)
      })
  })

// Fire-and-forget, matching AppMessageManager.appMessageClicked on iOS and the Android
// dialog: the popup closes and follows the link whether or not the server records the
// click. Losing one row of click attribution is cheaper than making the user wait on a
// dialog, or stranding them on it if the call fails.
export const appMessageClick = appMessageId => (dispatch, getState, token) =>
  new Promise(resolve => {
    superagent
      .put(`${__API_URI__}/AppMessage/Click`)
      .query({ appMessageId })
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end(err => {
        if (err) console.warn('appMessageClick failed.', err)
        resolve()
      })
  })
